export const GOOGLE_MAPS_API_KEY = "AIzaSyBhEKjR24JixtPLZjKNWHT7MkpegsZRXGs";
export const MODE = "prod";



// WEBPACK FOOTER //
// ./src/constants/constants.js